module.exports = __webpack_public_path__ + "static/media/colourOptions2-min.c9c78d2d.JPG";